/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var SortDirection;
(function (SortDirection) {
    SortDirection["Asc"] = "Asc";
    SortDirection["Desc"] = "Desc";
})(SortDirection || (SortDirection = {}));
export function SortDirectionFromJSON(json) {
    return SortDirectionFromJSONTyped(json, false);
}
export function SortDirectionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function SortDirectionToJSON(value) {
    return value;
}
